import { getContactError } from "../../utils/utils";

export const CCVServiceValidation = async (params) => {
  const { utillityAccountData, measureId, verifyUserAccount, storeContact, customErrors, productInfo } = params; 

  let result = {
    isValid: false,
    utillityAccountData: {},
    error : {
      message1: "",
      message2: ""
    }
  }
  if (utillityAccountData && measureId) {
    const verification = utillityAccountData[0].verification;
    const qualification = utillityAccountData[0].qualification;
    if (verification?.verified === true || verification?.verified === 'true') {
        if (verifyUserAccount !== false && qualification && qualification.length > 0) {
            const categoryMatched = qualification.find(
                (categoryEle) =>
                  categoryEle.categoryid === measureId
            );
            if (categoryMatched?.qualified) {

              if(productInfo.cr_incentive_count &&  productInfo.cr_incentive_count > categoryMatched?.quantitymax) {
                result.isValid = false;
                result.error.message1 = customErrors?.pastParticipationQuantityCustomError || customErrors?.notEligibilityError;
                result.error.message2 = verification?.messagefooter;
                return result;
              }

              result.isValid = true;
              result.utillityAccountData = utillityAccountData;
            } else {
              result.isValid = false;
              result.error.message1 = categoryMatched?.message || customErrors.notEligibilityError;
              result.error.message2 = verification?.messagefooter;
            }
        } else if (verifyUserAccount === false) {
          result.isValid = true;
          result.utillityAccountData = utillityAccountData;
        } else {
          result.isValid = false;
          result.error.message1 = verification?.message;
          result.error.message2 = verification?.messagefooter;
        }
    } else {
      result.isValid = false;
      if (verification?.verified === false || verification?.verified === 'false') {
          // if service have a message it should be displayed
          if (
              verification?.message &&
              verification?.message !== "n/a"
          ) {
            result.error.message1 = verification?.message;
            result.error.message2 = verification?.messagefooter;
          } else {
            result.error.message1 = customErrors.notEligibilityError;
          }
      } else {
        result.error.message1 = customErrors.genericError;
        result.error.message2 = getContactError(storeContact);
      }
    }
  } else {
    result.isValid = false;
    result.error.message1 = customErrors.genericError;
    result.error.message2 = getContactError(storeContact);
  }
  return result;
}

export const CCVServiceValidationV2 = async (params) => {
  const { utillityAccountData, measureId, measureClassId, verifyUserAccount, storeContact, customErrors, productInfo } = params;

  let result = {
    isValid: false,
    utillityAccountData: {},
    error : {
      message1: "",
      message2: ""
    }
  }
  if (utillityAccountData && measureClassId) {
    const verification = utillityAccountData[0].verification;
    const qualification = utillityAccountData[0].qualification;
    if (verification?.verified === true || verification?.verified === 'true') {
        if (verifyUserAccount !== false && qualification && qualification.length > 0) {
          let categoryMatched = qualification.find(categoryEle => {
            return (categoryEle.measureclassid == measureClassId ||
                    categoryEle.measure_category_id == measureId ||
                    categoryEle.categoryid == measureId
            );
          });
          let quantitymax = 0;
            if (categoryMatched?.qualified) {
              quantitymax = categoryMatched?.quantitymax ? categoryMatched?.quantitymax : categoryMatched?.quantities?.remaining;
              if (productInfo.cr_incentive_count &&  productInfo.cr_incentive_count > quantitymax) {
                result.isValid = false;
                result.error.message1 = customErrors?.pastParticipationQuantityCustomError || customErrors?.notEligibilityError;
                result.error.message2 = verification?.messagefooter;
                return result;
              }

              result.isValid = true;
              result.utillityAccountData = utillityAccountData;
            } else {
              result.isValid = false;
              result.error.message1 = categoryMatched?.message || customErrors.notEligibilityError;
              result.error.message2 = verification?.messagefooter;
            }
        } else if (verifyUserAccount === false) {
          result.isValid = true;
          result.utillityAccountData = utillityAccountData;
        } else {
          result.isValid = false;
          result.error.message1 = verification?.message;
          result.error.message2 = verification?.messagefooter;
        }
    } else {
      result.isValid = false;
      if (verification?.verified === false || verification?.verified === 'false') {
          // if service have a message it should be displayed
          if (
              verification?.message &&
              verification?.message !== "n/a"
          ) {
            result.error.message1 = verification?.message;
            result.error.message2 = verification?.messagefooter;
          } else {
            result.error.message1 = customErrors.notEligibilityError;
          }
      } else {
        result.error.message1 = customErrors.genericError;
        result.error.message2 = getContactError(storeContact);
      }
    }
  } else {
    result.isValid = false;
    result.error.message1 = customErrors.genericError;
    result.error.message2 = getContactError(storeContact);
  }
  return result;
}
